import { Box, CssBaseline } from '@mui/material';
import { Outlet } from 'react-router-dom';
import './layout.css';

import SideNav from './sidenav';
import Appbar from './appBar';
import { useState } from 'react';
import CustomDivider from '@ui-components/Divider/CustomDivider';

export default function OperationsLayout() {
  const [isSideNavOpen, setIsSideNavOpen] = useState(true);

  const handleSideNavToggle = () => {
    setIsSideNavOpen(!isSideNavOpen);
  };
  return (
    <Box className="container">
      <CssBaseline />
      <SideNav isOpen={isSideNavOpen} onToggle={handleSideNavToggle} />
      {/* Main Content with Outlet */}
      <Box
        component="main"
        className="content-element"
        sx={{
          marginLeft: isSideNavOpen ? '180px' : '50px', // Adjust these values as needed
          // transition: 'margin-left 0.3s ease', // Smooth transition
        }}
      >
        <Appbar />
        <CustomDivider variant="fullWidth" orientation="horizontal" />
        <Outlet />
      </Box>
    </Box>
  );
}
